var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgUser = function SvgUser(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 3.5,
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M12 14c4.977 0 6.415 3.033 6.831 4.786.157.66-.381 1.214-1.06 1.214H6.229c-.679 0-1.217-.553-1.06-1.214C5.585 17.033 7.023 14 12 14Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;